import type { Config } from './config.type'
import domain from './domain'

const config: Config = {
  appName: 'Stampede Product',
  prod: false,
  blog: `https://${domain}/blog/category/tips/feed/`,
  url: {
    api: '',
    selfservice: `https://api-selfservice.prd.${domain}`,
    accounts: `https://accounts.stage.${domain}`,
    connect: `https://product.stage.${domain}`,
    nearly: 'https://wifi.stage.stampede.ai',
    mailchimp: `https://mailchimp.${domain}`,
    calculator: '//pricing.stampede.ai/calc',
    reviews: 'https://reviews.stage.stampede.ai',
    gifting: 'https://gifting.stampede.ai',
    forms: 'https://forms.stampede.ai',
    service: `https://service.stg.${domain}`,
    cypher: `https://cypher.stg.${domain}`,
    urlGenerator: `https://url-generator.stg.${domain}`,
    bookingIntegration: `https://bookings-intergrations.prd.${domain}`,
    bookings: `https://api-bookings.stg.${domain}`,
    booking_url: `https://booking.${domain}`,
    ordering_url: `https://ordering.${domain}`,
    app: `https://app.stage.${domain}`,
    notifications: `https://notifications.stg.${domain}`,
    reporting: `https://reporting.stg.${domain}`,
    inbox: `https://inbox.stg.${domain}`,
    morpheus: `https://morpheus.stg.${domain}`,
    neo: `https://neo.stg.${domain}`,
    inbox_email: '@stmpd-mail.com',
    trinity: `https://trinity.stg.${domain}`,
    loyalty: `https://loyalty.stg.${domain}`,
    agent_smith: `https://agent-smith.stg.${domain}`,
    loyalty_end_user: `https://loyalty.stage.${domain}`,
    zion: `https://zion.stg.${domain}`,
    operator: `https://operator.stg.${domain}`,
    voiceWs: `wss://sbc-ws.stg.${domain}`,
    voiceDemoNumber: '+447000000001',
    reports: `https://reports-api.stg.${domain}`,
    auth: `https://auth.stage.${domain}`,
    integrations: `https://bookings-intergrations.stg.${domain}`,
    billing: `https://billing.stg.${domain}`,
    tank: `https://tank.stg.${domain}`,
    sites: `https://sites.stage.${domain}`,
    vpn: `https://vpn.stage.${domain}`,
    trunk: `https://trunk.stg.${domain}`,
    eve: `https://eve.agent.stampede.ai`,
    mouse: `https://mouse.stg.${domain}`,
  },
  sockets: {
    booking_items: 'wss://tn67hcqv9c.execute-api.eu-west-1.amazonaws.com/stage',
    pusher_client_key: '9ab1d1e08c1b2f35727c',
  },
  auth: {
    clientId: '',
    clientSecret: '1234',
    redirectUri: `https://product.stage.${domain}/code`,
    scope: 'ALL',
  },
  apiOauth: {
    clientId:
      '348453694666-6ttcbmf9bb6b0e69jr1s0qgmehb10n6a.apps.googleusercontent.com',
    redirectUri: `https://product.stage.${domain}/oauth/google/callback`,
  },
  localStorageKeys: {
    userCredentials: 'user-credentials',
  },
  googleMapsKey: 'AIzaSyAuKRd435IPeG6yP9zkiiHlAEWv4K_Moq8',
  mapboxToken:
    'pk.eyJ1Ijoic3RhbXBlZGUtcGF0cmljayIsImEiOiJjbWJzNTVoYmUwZzBlMmtzZHBmZnE5emc3In0.c_iVngJLwLCaoRsvoiVWcA',
  language: 'en_GB',
  stripeKey: 'pk_test_FDv3YMxZU4H6WutGopfWYl7J',
  enableWhyDidYouUpdate: false,
}

export default config
